<app-data-set
	#dataSet
	[dataSource]="dataSource"
	[rowId]="rowId"
	defaultPresentationMode="table"
	firstColumnProperty="mobileUUID"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="mobileUUID"
				[defaultFilterLabel]="filterLabels.mobileUUID"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="4">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.mobileUUID }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('mobileUUID')"
								data-automation-id="mobileUUID-input"
								(ngModelChange)="dataSet.filter('mobileUUID', filterLabels.mobileUUID, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.status }}</mat-label>
							<mat-select
								[ngModel]="dataSet.filter('statusId')"
								data-automation-id="status-picker"
								(ngModelChange)="dataSet.filter('statusId', filterLabels.status, $event, statusFilterOptions)"
							>
								@for (option of statusFilterOptions; track option) {
									<mat-option [value]="option.value" [attr.data-automation-id]="'status-' + option.label"
										>{{ option.label }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.requestTime }}</mat-label>
							<input
								matInput
								[matDatepicker]="requestTimePicker"
								[ngModel]="dataSet.filter('utcRequestTime')"
								(ngModelChange)="dataSet.filter('utcRequestTime', filterLabels.requestTime, $event)"
								data-automation-id="request-time-input"
							/>
							<mat-datepicker-toggle
								matSuffix
								class="date-picker-primary-blue"
								[for]="requestTimePicker"
								data-automation-id="request-time-toggle"
							></mat-datepicker-toggle>
							<mat-datepicker
								#requestTimePicker
								disabled="false"
								data-automation-id="request-time-datepicker"
							></mat-datepicker>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.note }}</mat-label>
							<input
								matInput
								data-automation-id="role-name-input"
								[ngModel]="dataSet.filter('note')"
								(ngModelChange)="dataSet.filter('note', filterLabels.note, $event)"
							/>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>

		<ng-container>
			<app-button-toggle
				[activeLeftButtonIcon]="'sl-hamburger-menu-active'"
				[inactiveLeftButtonIcon]="'sl-hamburger-menu-inactive'"
				[activeRightButtonIcon]="'sl-three-users-active'"
				[inactiveRightButtonIcon]="'sl-three-users-inactive'"
				[(selectedButton)]="selectedButton"
				(selectedButtonChange)="whitelistPageChanged($event)"
			></app-button-toggle>
		</ng-container>
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (loadingService.isLoading(getWhitelistUserListForCompanyLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(getWhitelistUserListForCompanyLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td
						class="mat-cell"
						[colSpan]="displayedColumns.length"
						i18n="@@dataSetTable-noRecordsFound"
						class="font-color-gray"
					>
						No records found.
					</td>
				</tr>
				<ng-container matColumnDef="mobileUUID">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userWhitelist-mobileId">Mobile ID</th>
					<!-- Code below is formatted the same way mobile does it. If this method is changed, then the mobile code should be as well. -->
					<td mat-cell *matCellDef="let row" class="font-color-gray">
						{{ formatWhitelistIdForDisplay(row.mobileUUID) }}
					</td>
				</ng-container>

				<ng-container matColumnDef="status">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userWhitelist-status">Status</th>
					<td mat-cell *matCellDef="let row" class="font-color-gray">
						<mat-chip-set>
							<mat-chip class="status-chip" [ngClass]="getChipStyling(row.status)">
								&bull;&NonBreakingSpace;{{ capitalizeFirstLetter(row.status) }}
							</mat-chip>
						</mat-chip-set>
					</td>
				</ng-container>

				<ng-container matColumnDef="utcRequestTime">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userWhitelist-requestTime">Request Time</th>
					<td mat-cell *matCellDef="let row" class="font-color-gray">
						<div>{{ row.utcRequestTime | billingStartDateFilter }}</div>
						<div>{{ row.utcRequestTime | requestTimeToLocal }}</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="note">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@userWhitelist-userStatus" style="width: 24%">
						Note
					</th>
					<td mat-cell *matCellDef="let row; let i = index" class="font-color-gray" style="width: 24%">
						<!-- Showing the note -->
						@if (row.note || (allowMutate && row.id === onAddNoteFocusRowId)) {
							<div
								[attr.contenteditable]="allowMutate ? true : null"
								[innerHTML]="row.note ? formatNoteNewLines(row.note) : ''"
								class="note-input"
								[id]="'note-input-' + row.id"
								(blur)="unfocusInput($event, row)"
								(keydown)="checkInputOnKeyDown($event, row)"
							></div>
						}

						@if (allowMutate && !row.note && row.status === 'active' && row.id !== onAddNoteFocusRowId) {
							<div class="add-note-button-container">
								<!-- Button to add notes -->
								<button
									class="add-note-button"
									[attr.data-automation-id]="'user-' + row.id + '-button-add-note'"
									(click)="focusOnInput(row)"
								>
									<span class="add-note-plus-symbol"> + </span>
									<span i18n="@@userWhitelist-addButton"> Add </span>
								</button>
							</div>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="options">
					<th mat-header-cell *matHeaderCellDef class="percent-width-20"></th>
					<td mat-cell *matCellDef="let row; let i = index" class="percent-width-20">
						@if (allowMutate && row.status === 'pending') {
							<div class="whitelist-button-container">
								<button
									class="primary-small-button primary-small-button-wider"
									(click)="acceptWhitelist(row)"
									[attr.data-automation-id]="'user-' + row.id + '-button-accept'"
								>
									<span>
										<mat-icon class="checkmark align-center margin-top">check</mat-icon>
										<span i18n="@@userWhitelist-acceptButton" class="whitelist-button-text">Accept</span>
									</span>
								</button>
								<button
									class="secondary-small-button secondary-small-button-wider"
									(click)="declineWhitelist(row)"
									[attr.data-automation-id]="'user-' + row.id + '-button-decline'"
								>
									<span>
										<mat-icon mat-button class="dismiss-icon" svgIcon="sl-dismiss"></mat-icon>
										<span i18n="@@userWhitelist-declineButton" class="whitelist-button-text decline-button-text"
											>Decline</span
										>
									</span>
								</button>
							</div>
						}
						@if (allowMutate && row.status === 'active') {
							<div class="whitelist-button-container">
								<button
									class="warning-small-button primary-small-button-wider"
									(click)="deactivateWhitelist(row)"
									[attr.data-automation-id]="'user-' + row.id + '-button-warning'"
								>
									<span i18n="@@userWhitelist-deactivateButton" class="whitelist-button-text deactivate-button-text"
										>Deactivate</span
									>
								</button>
							</div>
						}
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					[attr.data-automation-id]="'user-' + row.id + '-row'"
					class="user-row-container"
				></tr>
			</table>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
